import axios from 'axios';

export default {
    submitCheckin(checkin) {
        var options = {
            url: window.apiUrl + '/global-checkin',
            method: 'POST',
            data: { checkin: checkin },
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    recordAttendance(meetingId) {
        var options = {
            url: window.apiUrl + '/global-meeting/attendance',
            method: 'POST',
            data: { meetingId: meetingId },
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    get() {
        var options = {
            url: window.apiUrl + '/global-meetings',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getCheckins() {
        var options = {
            url: window.apiUrl + '/global-checkins',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getMine() {
        var options = {
            url: window.apiUrl + '/my-global-meetings',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getOne(id) {
        var options = {
            url: window.apiUrl + '/global-meeting/' + id,
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    toggleSignup(id, toggle) {
        var options = {
            url: window.apiUrl + '/global-meeting-signup',
            method: 'POST',
            data: {
                signup: {
                    meetingId: id,
                    toggle: toggle
                }
            },
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
}



// WEBPACK FOOTER //
// ./src/services/global-meetings/index.js